import Column from '@app/components/layout/Column'
import useMediaQuery from '@app/util/useMediaQuery'
import { SubsidyCard } from '@app/components/blocks/card/SubsidyCard'
import { GeoViewModel } from './models'

export const Subsidies = ({ region: _region }: { region: GeoViewModel }) => {
  const isMobile = useMediaQuery()
  const _largerGap = isMobile ? '2rem' : '3.5rem'
  const smallerGap = isMobile ? '1rem' : '1.5rem'

  return (
    <Column gap={smallerGap} alignItems="stretch">
      <SubsidyCard
        title="Subsidie Knelpuntenpot woningrealisatie Drenthe"
        description="Voor het in gang krijgen van woningbouwprojecten waarbij een financieel tekort ontstaat."
      />
      <SubsidyCard
        title="Subsidie Knelpuntenpot woningrealisatie Drenthe"
        description="Voor het in gang krijgen van woningbouwprojecten waarbij een financieel tekort ontstaat."
      />
      <SubsidyCard
        title="Subsidie Knelpuntenpot woningrealisatie Drenthe"
        description="Voor het in gang krijgen van woningbouwprojecten waarbij een financieel tekort ontstaat."
      />
    </Column>
  )
}
